import { render, staticRenderFns } from "./AroundMngt.vue?vue&type=template&id=6708c306"
import script from "./AroundMngt.vue?vue&type=script&lang=js"
export * from "./AroundMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports